import type { TAvailableValuesType } from '../../../../../../types/components/components.type';
import type { TFunction } from '../../../../../../types/i18n/i18n.type';
import type { ISignallerFormState } from '../../components/signallerForm/signallerForm.type';
import type { Base64String } from '@pw-spk/general-app-web-cryptography';

export const PDF_CONTENT_TYPE = 'application/pdf';

export interface IEncryptSymmetricKeyReturn {
  encryptedSymmetricKey: Base64String;
  publicKeyId: string;
}

export interface IEncryptSymmetricKeyForClientReturn {
  encryptedSymmetricKey: Base64String;
  password: string;
  salt: Base64String;
}

export type TIsAnonimaParams = Pick<
  ICreatePDFFileParams,
  'reporter' | 'address' | 'email' | 'phone'
>;

export interface ICreatePDFFileParams {
  creationDate: string;
  reportNumber: string;
  reporter: ISignallerFormState['reporter'];
  subject: ISignallerFormState['subject'];
  description: ISignallerFormState['description'];
  reportedPersson: ISignallerFormState['reportedPersson'];
  witness: ISignallerFormState['witness'];
  evidence: ISignallerFormState['evidence'];
  email: ISignallerFormState['email'];
  phone: ISignallerFormState['phone'];
  relationWithOrganization: ISignallerFormState['relationWithOrganization'];
  address: string;
  personalDataDisclosure: boolean;
  evidenceFiles: string[];
  t: TFunction;
  availableSubjects: TAvailableValuesType;
}

export interface ISendEmailParams {
  hash: Base64String;
  encryptedHash: Base64String;
  reportNumber: string;
  email: string;
  client: string;
  clientFullName: string;
  attachment:
    | {
        fileName: string;
        content: Base64String;
      }
    | undefined;
}

export interface IEncryptPdfFileParams {
  password: string;
  confirmPassword: string;
  file: Uint8Array<ArrayBuffer>;
}
